import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

interface IProps {
  size: string;
}

export const Logo: React.FC<IProps> = ({ size }) => {
  return (
    <Link to="/">
      {size === 'full' && (
        <StaticImage
          src="../../../images/prydwen_logo_small.png"
          alt="Prydwen"
          className="logo-full"
        />
      )}
      {size === 'minimal' && (
        <StaticImage
          src="../../../images/prydwen_logo_min.png"
          alt="Prydwen"
          className="logo-minimal"
        />
      )}
    </Link>
  );
};
